<template>
  <span class="feature-type-icon" :data-geometry-icon="type">
    <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="20" height="20">
      <path
        v-if="type === 'point'"
        data-shape="point"
        d="M10 2.5a5 5 0 0 0-5 5c0 3.7 5 10 5 10s5-6.3 5-10a5 5 0 0 0-5-5Zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
        fill="currentColor"
      />
      <polyline
        v-else-if="type === 'path'"
        data-shape="path"
        points="2.5,15.5 7,6 12,12 17.5,4.5"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <polygon
        v-else
        data-shape="polygon"
        points="3,15.5 5.5,5 14,3 17,11 11,17"
        fill="currentColor"
        fill-opacity="0.2"
        stroke="currentColor"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
  </span>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ["point", "path", "polygon"].includes(value),
  },
})
</script>

<style scoped>
.feature-type-icon {
  display: inline-flex;
  flex: 0 0 auto;
}
</style>
